module.exports = __webpack_public_path__ + "static/media/08_publimetro.7232ab79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/scrap-step/press/08_publimetro.png
// module id = 541
// module chunks = 0